// Centralised structured-data + page-level metadata.

export const PERSON_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Hallie',
  jobTitle: 'Operations & Systems Specialist',
  worksFor: {
    '@type': 'Organization',
    name: 'Eureka1',
  },
  description:
    'Operations & Systems Specialist with more than 15 years of experience helping service-based businesses improve efficiency, strengthen customer experiences, and build reliable operational systems.',
  knowsAbout: [
    'Operations Management',
    'Business Systems',
    'Customer Experience',
    'CRM Administration',
    'Process Optimization',
    'Website Design',
    'Local SEO',
    'Social Media Management',
  ],
  image:
    'https://customer-assets.emergentagent.com/job_ops-excellence-28/artifacts/euqbi532_20260520_010613-IMG_STYLE.jpg',
};

export const BUSINESS_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'Eureka1',
  founder: { '@type': 'Person', name: 'Hallie' },
  slogan: 'Reliable Support, Handled with Care.',
  description:
    'Eureka1 is an operations and systems practice helping service-based businesses streamline operations, improve customer experiences, and build reliable systems that support sustainable growth.',
  areaServed: 'Worldwide',
  url: 'https://halliev.com',
};

export const buildServiceSchema = (service) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: service.name,
  description: service.summary,
  provider: { '@type': 'Person', name: 'Hallie' },
  serviceType: service.name,
  audience: { '@type': 'BusinessAudience', audienceType: 'Service-based businesses' },
});

export const buildFAQSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});

export const buildArticleSchema = (post) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: post.title,
  datePublished: post.date,
  author: { '@type': 'Person', name: 'Hallie' },
  image: post.image,
  articleSection: post.category,
});
